function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import { Link } from '../Link/Link';
import styles from './BypassBlock.module.less';
export var BypassBlock = function BypassBlock(_ref) {
  var className = _ref.className,
      dangerouslyForceVisible = _ref.dangerouslyForceVisible,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Skip to content' : _ref$label,
      _ref$targetId = _ref.targetId,
      targetId = _ref$targetId === void 0 ? 'main' : _ref$targetId;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.container, className, _defineProperty({}, styles.forceVisible, dangerouslyForceVisible))
  }, /*#__PURE__*/React.createElement(Link, {
    href: "#".concat(targetId),
    bold: true
  }, label));
};